import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import Select from "../../components/form/Select";
import SelectAjax from "../../components/form/SelectAjax";
import BtBloco from '../../components/buttons/BtBloco';
import DateRangePickerWrapper from "../../components/form/DateRangePickerWrapper";
import Ws from '../../config/Ws';
import TipoPlanilha from "./TipoPlanilha";
import TIPOS_PLANILHA from "../../data/TiposPlanilha";
import Random from "../../utils/strings/Random";
import ButtonTipoTreino from './ButtonTipoTreino';
import SEXOS from "../../data/Sexos";
import Component from "./Component";
import Requisitions from "../../utils/requisitions/Requisitions";
import Loader from "../../components/loader/Loader";
import STRINGS from './../../data/language/language';
import Dialog from '../../components/alert/Dialog';
import {FormDataToJson} from '../../utils/json/Json';
import moment from 'moment';
import PAGES from '../../config/Pages';

const CLASS_SEXO_REFERENCE = "wrapper-sexo-";

class Page extends React.Component{
  constructor (props){
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.clonePlanilha = this.clonePlanilha.bind(this);
    this.state = {
      idPlanilha: props.detalhe ? props.detalhe.id : null,
      formulario:Random(7),
      strings:STRINGS[window.LANGUAGE],
      boxes: props.detalhe ? this.getBoxes(props.detalhe) : this.getBoxes([])
    };
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  getBoxes (__args__){
    return <Component key={Random(5)} data={__args__}></Component>;
  }

  checkForm (e) {
    let dadosForm = {};
    const {
      atencao,
      salvoSucesso,
      erroSalvarBloco,
      preenchaCamposAsterisco,
      escolhaOsExercicios,
      erroSalvar,
      escolhaQntDias,
      adicioneBlocos,
      qntBlocosMenorQueQntDias,
      erroBlocoPlanilha,
      digiteNomePlanilha,
      erroDataPlanilha,
      erroDataSexoPlanilha,
      errorSavePlanilha
    }
    = this.state.strings;

    //retorna o formulário da página
    const form = this.getFormElement();

    let nomePlanilha = form.querySelectorAll("[name='nome_planilha_treino']")[0].value;
    let dti = form.querySelectorAll("[name='dti']")[0].value;
    let dtf = form.querySelectorAll("[name='dtf']")[0].value;

    //checa o nome da planilha
    if(!nomePlanilha){
      let msg = {
        title: atencao,
        text: digiteNomePlanilha
      };
      Dialog.create(msg);
      return false;
    }

    //transforma o formData em um json
    const formData = new FormData(e.target);
    var object = FormDataToJson(formData);

    //checa a data para verificar se o dia inicial e final tem 6 dias
    const dayArr = object.dtf.split('/');
    const dayFormated = dayArr[2]+'-'+dayArr[1]+"-"+dayArr[0];
    const new_date = moment(object.dtf, "DD/MM/YYYY").subtract(6, 'days');
    const day = new_date.format('DD');
    const month = new_date.format('MM');
    const year = new_date.format('YYYY');
    const diaCheck = day + '/' + month + '/' + year;

    if(object.dti !== diaCheck){
      let msg = {
        title: atencao,
        text: erroDataPlanilha
      };
      Dialog.create(msg);
      return false;
    }

    //-----------
    //teremos sempre duas planilhas detalhe
    //elas são referentes aos blocos masculino e feminino
    let obj = { nome: nomePlanilha, dti: dti, dtf: dtf, local_treino: 'academia' };

    for (let i= 0; i< SEXOS.length ; i++ ){
      const identifier = SEXOS[i].identifier;

      const data = this.getPlanilhaBySexo(identifier);

      if(data){
        obj[identifier] = data;
      }else{
        return false;
        break;
      }
    }

    //---------
    const id = this.state.idPlanilha;

    if(id){
      obj.id = id;
    }

    return obj;
  }

  getPlanilhaBySexo (planilha){
    //objeto que conterá todos os blocos de planilha
    let obj = {};
    const form = this.getFormElement();
    //retornamos os itens de acordo com o tipo de planilha
    const wrapper = form.querySelectorAll("[data-id='"+planilha+"']")[0];

    //damos um loop nos tipos de planilha
    for (let i= 0; i< TIPOS_PLANILHA.length ; i++ ){
      const identifier = TIPOS_PLANILHA[i].identifier;
      const wrapperTipo = wrapper.querySelectorAll("[data-id='"+identifier+"']")[0];

      const data = this.getPlanilhaByTipo({ identifier:identifier, wrapper: wrapperTipo });

      if(data){
        obj[identifier] = data;
      }else{
        return false;
        break;
      }
    }

    return obj;
  }

  getPlanilhaByTipo (args){
    const { atencao,msgQntPlanilhasMenorQue5 } = this.state.strings;
    const box = args.wrapper;
    const wrapperDetalhes = box.querySelectorAll("[data-id='js-detalhes-tipo-planilha']");
    const cadencia = box.querySelectorAll("[name='cadencia']")[0] ? box.querySelectorAll("[name='cadencia']")[0].value : '';
    const repeticoes = box.querySelectorAll("[name='repeticoes']")[0] ? box.querySelectorAll("[name='repeticoes']")[0].value : '';
    const intervalo = box.querySelectorAll("[name='intervalo']")[0] ? box.querySelectorAll("[name='intervalo']")[0].value : '';
    const observacoes = box.querySelectorAll("[name='observacoes']")[0].value;

    let obj = {
      cadencia: cadencia,
      repeticoes: repeticoes,
      intervalo: intervalo,
      observacoes: observacoes,
      blocos: []
    };

    //bloco de planilha
    const classWrapperBlocoPlanilha = 'wrapper-bloco-planilha';
    const wrapperBlocoPlanilha = box.getElementsByClassName(classWrapperBlocoPlanilha);

    //caso no número de planilhas seja menor que 5 (2,3,4,5 e 6 dias)
    //damos um alert dizendo que a planilha deve ter 5 elementos
    //console.log(box);
    if(wrapperBlocoPlanilha.length < 5){
      let msg = {
        title: atencao,
        text: msgQntPlanilhasMenorQue5
      };
      Dialog.create(msg);
      return false;
    }

    //damos um loop nos blocos de planilha
    for (let i= 0; i< wrapperBlocoPlanilha.length ; i++ ){
      const box = wrapperBlocoPlanilha[i];
      const data = this.getBlocoPlanilha(box);

      if(data){
        obj.blocos.push(data);
      }else{
        return false;
      }
    }

    return obj;
  }

  getBlocoPlanilha(args) {

    const { verifiquePlanilhas, atencao } = this.state.strings;
    const classBlocoPlanilhaWrapper = 'bloco-planilha-wrapper';
    const blocosPlanilhaWrapper = args.getElementsByClassName(classBlocoPlanilhaWrapper);
    const qntDias = args.querySelectorAll("[name='quantidade_dias']")[0].value;

    if(qntDias != blocosPlanilhaWrapper.length){
      let msg = {
        title: atencao,
        text: verifiquePlanilhas
      };
      Dialog.create(msg);
      return false;
    }

    let obj = {
      blocos: [],
      qntDias: qntDias
    };

    for (let i= 0; i< blocosPlanilhaWrapper.length ; i++ ){
      const box = blocosPlanilhaWrapper[i];
      const data = this.getBloco({box: box});

      if(data){
        obj.blocos.push(data);
      }else{
        return false;
      }

    }

    return obj;

  }

  getBloco (args){
    const box = args.box;
    const cadencia = box.querySelectorAll("[name='cadencia']")[0].value;
    const repeticoes = box.querySelectorAll("[name='repeticoes']")[0].value;
    const intervalo = box.querySelectorAll("[name='intervalo']")[0].value;
    const observacoes = box.querySelectorAll("[name='observacoes']")[0].value;
    const dias_semana = box.querySelectorAll("[name='dias_semana']")[0].value;

    let obj = {
      cadencia: cadencia,
      repeticoes: repeticoes,
      intervalo: intervalo,
      observacoes: observacoes,
      dias_semana: dias_semana
    }

    const { algumaPlanilhaNaoTemExercico, atencao } = this.state.strings;
    let exercicios = [];
    let elements = box.querySelectorAll('.item-listagem');

    //é obrigatório adicionar exercícios
    if(elements.length<=0){
      let msg = {
        title: atencao,
        text: algumaPlanilhaNaoTemExercico
      };
      Dialog.create(msg);
      return false;
    }

    elements.forEach((value, key)=>{
      let idEl = value.getAttribute('data-id');
      exercicios.push(idEl);
    });

    obj.exercicios = exercicios;

    return obj;
  }

  handleSubmit (e){
    e.preventDefault();

    //---------------------------
    //---------------------------
    //remove o modal
    //this.props.modal.close();
    const dadosForm = this.checkForm(e);
    const self = this;
    const {atencao, salvoSucesso, errorSavePlanilha} = this.state.strings;

    if(!dadosForm){
      return false;
    }

    const _self = this;

    const history = this.props.history;

    Requisitions({
      url:Ws.planilhas_treino.save,
      data:JSON.stringify(dadosForm),
      sucess:function(data){
        if(data.status){
          _self.props.modal.close();
        }
        var msg;
        msg = {
          title: atencao,
          text: data.msg
        };
        Dialog.create(msg);

        history.push(PAGES.planilhasTreino);
      },
      error:function(data){
        var msg = {
          title: atencao,
          text: errorSavePlanilha
        };
        Dialog.create(msg);
      }
    });
  }

  clonePlanilha (e){
    let id = e.value;
    var _self = this;
    const {criandoPlanilha} = this.state.strings;

    Requisitions({
      url:Ws.planilhas_treino.detalhe,
      data:{id:id},
      sucess:function(data){
        let modal = new Loader();
        modal.open({title:criandoPlanilha});
        let p = new Promise((resolve, reject)=>{
          setTimeout(function(){
            _self.setState((prevState, props) => ({
              boxes: _self.getBoxes(data.item)
            }));
            resolve();
          }, 3000);
         }).then(result=>{
           modal.close();
        }).catch(reason=>{
          //console.warn('Failed!', reason);
        });
      },
      error:function(data){

      }
    });
  }

  getFormElement(){
    const idForm = this.state.formulario;
    const form = document.getElementById(idForm);
    return form;
  }

  render (){
    const id = this.props.detalhe ? <input type='hidden' name='id' value={this.props.detalhe.id} /> : '';
    const {cadastroPlanilha, nome_planilha, digiteAqui, dataInicio, dataFim, copiarPlanilha, salvar} = this.state.strings;
    const nome = this.props.detalhe ? this.props.detalhe.nome : '';
    const dti = this.props.detalhe ? this.props.detalhe.dti : null;
    const dtf = this.props.detalhe ? this.props.detalhe.dtf : null;

    return (
      <div>
        <MainTitle title={cadastroPlanilha}></MainTitle>
        <form id={this.state.formulario}  className="" onSubmit={this.handleSubmit}>
          <input type='hidden' name="local_treino" value="academia" />
          {id}
          <div className="pure-u-15-24">
            <TextInput value={nome} type='text' name="nome_planilha_treino" title={nome_planilha} placeholder={digiteAqui}></TextInput>
          </div>
          <div className="pure-u-9-24">
            <DateRangePickerWrapper
               dti={dti}
               dtf={dtf}
               titleDateInicio={dataInicio}
               titleDateFim={dataFim} />
          </div>
          <div></div>
            <div className="pure-u-15-24">
              <SelectAjax url={Ws.planilhas_treino.search} data={{local_treino: 'academia'}}  onChange={this.clonePlanilha} title={copiarPlanilha}/>
            </div>
            <div></div>
            {this.state.boxes}
          <br />
          <div className="separador"></div>
          <br />
          <div className="box-right-button"><Button type="submit" text={salvar} classes="bt-save bt-blue" /></div>
        </form>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/planilha-treino/Page.js